import PageWrapper from "../components/UI/PageWrapper";

const LendingPage = () => (
  <PageWrapper>
    <div className="mx-auto p-12 text-black rounded-lg profile-form flex flex-col gap-[2.875rem] min-h-screen">
      <h1 className="profile-info-text-size">Lending</h1>
    </div>
  </PageWrapper>
);

export default LendingPage;
